import React, { useEffect, useRef, useState } from 'react';

// Skaliert ein fest dimensioniertes Element (width x height) proportional
// auf die verfügbare Breite des Elternelements herunter, damit Schrift,
// QR-Code und Briefmarke auf kleinen Bildschirmen mitschrumpfen statt
// abgeschnitten zu werden.
export default function ScaleToFit({ width, height, children }) {
  const containerRef = useRef(null);
  const [scale, setScale] = useState(1);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    const updateScale = () => {
      const containerWidth = container.offsetWidth;
      if (containerWidth > 0) {
        setScale(Math.min(1, containerWidth / width));
      }
    };

    updateScale();

    const observer = new ResizeObserver(updateScale);
    observer.observe(container);
    return () => observer.disconnect();
  }, [width]);

  return (
    <div
      ref={containerRef}
      style={{
        width: '100%',
        height: `${height * scale}px`,
        overflow: 'hidden',
        position: 'relative',
      }}
    >
      <div
        style={{
          width: `${width}px`,
          height: `${height}px`,
          transform: `scale(${scale})`,
          transformOrigin: 'top left',
          position: 'absolute',
          top: 0,
          left: 0,
        }}
      >
        {children}
      </div>
    </div>
  );
}
